module.exports = __webpack_public_path__ + "fonts/500-normal-greek-ext.4b0156f.woff2";